var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.75211 1.10568C0.263955 1.59383 0.263955 2.38529 0.75211 2.87344L6.05538 8.17672L0.928829 13.3033C0.440674 13.7914 0.440674 14.5829 0.928829 15.071C1.41698 15.5592 2.20844 15.5592 2.6966 15.071L7.82315 9.94449L13.1265 15.2478C13.6146 15.736 14.4061 15.736 14.8942 15.2478C15.3824 14.7597 15.3824 13.9682 14.8942 13.48L9.59092 8.17672L15.071 2.69667C15.5591 2.20852 15.5591 1.41706 15.071 0.928906C14.5828 0.440751 13.7914 0.440752 13.3032 0.928907L7.82315 6.40895L2.51988 1.10568C2.03172 0.617522 1.24027 0.617522 0.75211 1.10568Z",
    fill: "#84B0DA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseSmall);
export default __webpack_public_path__ + "static/media/CloseSmall.8467c1c06de2ca19405f81a4b10643b9.svg";
export { ForwardRef as ReactComponent };